module.exports = __webpack_public_path__ + "static/deaf-republic-583ee92363d61d4765d2e9c7d009ee20.jpg";